import { ref, uploadBytes } from 'firebase/storage';
import { storage } from '@/config/firebase';
import { HIPAA_MAX_PDF_BYTES } from '../../functions/src/modules/hipaa/hipaaAssembly.shared';

interface UploadedSource { storagePath: string; size: number }
const prepared = new WeakMap<File, Map<string, { storagePath: string; uploaded: Promise<unknown> }>>();

/** Shared by client creation and replacement. A retry with the same File retains its upload identity. */
export async function uploadHipaaSourceFile(firmId: string, clientId: string, file: File): Promise<UploadedSource> {
  if (file.type !== 'application/pdf' || file.size < 1 || file.size > HIPAA_MAX_PDF_BYTES) throw new Error('Upload a PDF no larger than 10 MiB.');
  const key = `${firmId}/${clientId}`;
  const entries = prepared.get(file) ?? new Map();
  prepared.set(file, entries);
  let entry = entries.get(key);
  if (!entry) {
    const storagePath = `firms/${firmId}/clients/${clientId}/hipaa-source/${crypto.randomUUID()}.pdf`;
    const uploaded = Promise.resolve().then(() => uploadBytes(ref(storage, storagePath), file));
    entry = { storagePath, uploaded }; entries.set(key, entry);
    uploaded.catch(() => { entries.delete(key); });
  }
  await entry.uploaded;
  return { storagePath: entry.storagePath, size: file.size };
}
